import { getFeaturesToRender } from "./features.js";
import { CHANGE_FEATURES } from "@flights/branded-fares";
export const UNKNOWN_BRANDED_FARE_CABIN_CLASS = "UNKNOWN";
export const getBrandedFareCabinClass = (fare) => fare.brandedFareInfo.cabinClass || UNKNOWN_BRANDED_FARE_CABIN_CLASS;
export const getBrandedFareCabinClassPages = (brandedFareOffers) => {
    const pages = new Map();
    brandedFareOffers.forEach((fare, globalIndex) => {
        const cabinClass = getBrandedFareCabinClass(fare);
        const existingPage = pages.get(cabinClass);
        if (existingPage) {
            existingPage.fares.push({ fare, globalIndex });
            return;
        }
        pages.set(cabinClass, { cabinClass, fares: [{ fare, globalIndex }] });
    });
    return Array.from(pages.values());
};
export const isBaseFare = (fareToken, brandedFareOffers) => {
    return findFareIndex(fareToken, brandedFareOffers) === 0;
};
export const isFareFromHigherCabinClass = (fareToken, brandedFareOffers) => {
    const realCabinClassPages = getBrandedFareCabinClassPages(brandedFareOffers).filter((page) => page.cabinClass !== UNKNOWN_BRANDED_FARE_CABIN_CLASS);
    if (realCabinClassPages.length <= 1)
        return false;
    return realCabinClassPages.findIndex((page) => page.fares.some(({ fare }) => fare.token === fareToken)) > 0;
};
export const findFareIndex = (fareToken, brandedFareOffers) => {
    if (!brandedFareOffers)
        return;
    const index = brandedFareOffers.findIndex((offer) => offer.token === fareToken);
    return index < 0 ? undefined : index;
};
export const getFareWithName = (brandedFareOffers, fareName) => brandedFareOffers.find((offer) => offer.brandedFareInfo.fareName === fareName);
export const hasChangeFeatures = (brandedFareOffers) => brandedFareOffers.some((offer) => getFeaturesToRender(offer.brandedFareInfo).includedFeatures.some((feature) => CHANGE_FEATURES.includes(feature.featureName)));
export const hasExcludedCheckedBaggage = (brandedFareOffers, isPreCheckAndPay) => brandedFareOffers.some((offer) => getFeaturesToRender(offer.brandedFareInfo, {
    includeExcludedFeatures: true,
    isPreCheckAndPay
}).nonIncludedFeatures.some((feature) => feature.featureName === "CHECK_BAGGAGE"));
export const getUniqueUpsellFeaturesForFarePair = (baseFare, upsellFare) => {
    const getIncludedKey = (f) => ["CHECK_BAGGAGE", "PERSONAL_BAGGAGE", "CABIN_BAGGAGE"].includes(f.featureName) ? f.label : f.featureName;
    const baseIncludedFeatures = new Set(baseFare.brandedFareInfo.features.map(getIncludedKey));
    const baseSellableFeatures = new Set(baseFare.brandedFareInfo.sellableFeatures?.map((f) => f.featureName) ?? []);
    return [
        ...upsellFare.brandedFareInfo.features.filter((feature) => !baseIncludedFeatures.has(getIncludedKey(feature))),
        ...(upsellFare.brandedFareInfo.sellableFeatures?.filter((feature) => !baseSellableFeatures.has(feature.featureName)) ?? [])
    ];
};
export const getUniqueUpsellFeatures = (brandedFareOffers, baseFareIndex = 0, upsellFareIndex = 1) => {
    const baseFare = brandedFareOffers[baseFareIndex];
    const upsellFare = brandedFareOffers[upsellFareIndex];
    if (!baseFare || !upsellFare)
        return [];
    return getUniqueUpsellFeaturesForFarePair(baseFare, upsellFare);
};
